export default "__VITE_ASSET__DOxkYklh__"